import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Flow {
  id: string;
  flow_type: string;
}

export function useFlow(flowId: string | undefined) {
  const [flow, setFlow] = useState<Flow | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!flowId) {
      setIsLoading(false);
      return;
    }

    async function fetchFlow() {
      try {
        const { data, error: supabaseError } = await supabase
          .from('flows')
          .select('id, flow_type')
          .eq('id', flowId)
          .single();

        if (supabaseError) throw supabaseError;
        setFlow(data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
        setFlow(null);
      } finally {
        setIsLoading(false);
      }
    }

    fetchFlow();
  }, [flowId]);

  return { flow, isLoading, error };
} 